import React, { useEffect } from 'react';
import { initializeOffline, cleanupOffline } from '../services/database/OfflineManager';

export const OfflineProvider = ({ children }) => {
  useEffect(() => {
    initializeOffline();

    return () => {
      cleanupOffline();
    };
  }, []);

  return children;
};

export default OfflineProvider;
